export default __webpack_public_path__ + "static/media/challenges.465c95e6.png";